export const SOB_ANALYTICS_REPORTS_NAMESPACE = 'jbp-analytics-reports'

export const TRANSLATION_KEYS = {
  dashboardTitle: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--dashboard-title`,
  copiedMessage: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--copied-msg`,
  filters: {
    fYears: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-fYears`,
    rtm: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-rtm`,
    filtersLabel: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-label`,
    filtersClear: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-clear`,
    products: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-products`,
    partnerId: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-partner-id`,
    partnerIdTooltip: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-partner-id-tooltip`,
    showGlobalPartners: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--show-global-partner`,
    globalPartners: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--global-partner`,
    partnerTypes: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-partnerTypes`,
    geo: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-geo`,
    organizations: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-organizations`,
    pbms: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-pbms`,
    unAcknowledged: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-un-acknowledged`,
    unAcknowledgedTooltip: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-un-acknowledged-tooltip`,
    submitted: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-submitted`,
    submittedTooltip: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-submitted-tooltip`,
    obligatoryFieldLabel: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-obligatory-field-label`,
    acknowledgedFieldLabel: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-acknowledged-field-label`,
    managers: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-managers`,
    apply: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-apply`,
    clearFilters: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-clearFilters`,
    selectFilters: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-select-filters`,
    noFindData: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-no-find-data`,
    noFilteredData: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-no-filtered-data`,
    applyProductsFilter: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-apply-products-filter`,
    programTypeTitle: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-apply-program-type-title`,
    categoryTitle: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-apply-category-title`,
    subCategoryTitle: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-apply-sub-category-title`,
    normalPartners: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-normal-partners`,
    allAcknowledged: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-all-acknowledged`,
    onlyAcknowledged: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-only-acknowledged`,
    unacknowledged: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters-unacknowledged`,
  },
  localEntitiesSwitch: `${SOB_ANALYTICS_REPORTS_NAMESPACE}-local-entities-switch`,
  globalEntitiesSwitch: `${SOB_ANALYTICS_REPORTS_NAMESPACE}-global-entities-switch`,

  charts: {
    filteredCountAcknowledged: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--charts-filtered-count-acknowledged`,
    filteredCountUnacknowledged: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--charts-filtered-count-unacknowledged`,
    filteredCountAll: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--charts-filtered-count-all`,
    excludedFilteredCountAcknowledged: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--charts-excluded-filtered-count-acknowledged`,
    excludedFilteredCountUnacknowledged: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--charts-excluded-filtered-count-unacknowledged`,
    excludedFilteredCountAll: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--charts-excluded-filtered-count-all`,
    submittedFilteredCountAcknowledged: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--charts-submitted-filtered-count-acknowledged`,
    submittedFilteredCountUnacknowledged: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--charts-submitted-filtered-count-unacknowledged`,
    submittedFilteredCountAll: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--charts-submitted-filtered-count-all`,
    obligatoryFieldLabel: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--charts-obligatory-field-label`,
    managers: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--charts-managers`,
    apply: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--charts-apply`,
    pbmChartTitle: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--charts-pbm-chart-title`,
    dbmChartTitle: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--charts-dbm-chart-title`,
    pbmChartCount: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--charts-pbm-chart-count`,
    barChartTitle: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--charts-bar-chart-title`,
    globalBarChartTitle: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--charts-global-bar-chart-title`,
    pieChartTitle: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--charts-pie-chart-title`,
    byMarket: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--charts-by-market`,
    byCountry: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--charts-by-country`,
  },
  table: {
    market: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-market`,
    partnerName: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-partner-name`,
    globalPartnerName: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-global-partner-name`,
    openPartnerPlan: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-open-partner-plan`,
    pid: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-pid`,
    globalPartnerPid: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-global-pid`,
    location: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-location`,
    partnerFlag: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-partner-flag`,
    pbm: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-pbm`,
    dbm: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-dbm`,
    manager: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-manager`,
    status: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-status`,
    country: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-country`,
    products: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-products`,
    specs: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-specs`,
    isAcknowledged: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-isacknowledged`,
    actuals: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-actuals`,
    plans: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-plans`,
    actualsRevenue: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-actuals-revenue`,
    plansRevenue: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-plans-revenue`,
    acknowledged: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-acknowledged`,

    sobColumn: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-sob-column`,
    sobColumnTotal: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-sob-column-total`,
    revenueColumn: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-revenue-column`,
    revenueColumnTotal: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-revenue-column-total`,
    actualsSelect: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-actuals-select`,
    plansSelect: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-plans-select`,
    sortColumnSelect: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--table-sort-column-select`,
  },
  acknowledgeStatus: {
    acknowledged: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--acknowledged-status-acknowledged`,
    notAcknowledged: `${SOB_ANALYTICS_REPORTS_NAMESPACE}--acknowledged-status-not-acknowledged`,
  },
}
